export enum RegisterTypeEnum {
    S,
    FV,
    V,
    C,
    P,
    LT,
}
